import { Injectable } from '@angular/core';
import {BehaviorSubject, pipe} from 'rxjs';
import { Constants } from '../models/constants';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Config} from "../config";

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  // Observable to handle authentication
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token: string = null;
  static tokenLoading: boolean = false;


  constructor(
    private router: Router,
    private config: Config,
    private httpClient: HttpClient
  ) {
    this.loadToken();
  }

  // Determine wheter user is logged in or not by getting token from Storage
  async loadToken() {
    this.token = this.token ?? localStorage.getItem(Constants.TOKEN);

    if (this.token && !AuthService.tokenLoading) {
      AuthService.tokenLoading = true;

      //console.log('token: ' + token);
        //this.router.navigateByUrl('home/buecherei', { replaceUrl: true });
        // refresh token
        this.httpClient.post(this.config.REFRESH_API, null, {
          'headers': this.getToken()
        }).subscribe(
          dataResult => {
            //console.log('new token: ' + dataResult['access_token']);
            localStorage.setItem(Constants.TOKEN, dataResult['access_token']);
            this.token = dataResult['access_token'];

            AuthService.tokenLoading = false;

            this.isAuthenticated.next(true);
          },
          error => {}
        );

       this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  getToken(isFile = false): any
  {
    /*
    let headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + this.token);
    */

    let headers = {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.token
    }

    if(!isFile) headers['Content-Type'] = 'application/json';

    return new Headers(headers);
  }


  isSignedIn(): boolean {
    return this.isAuthenticated.value;
  }

  // Clear token and branch from user and redirect to login page once logged out
  async logout() {
    localStorage.removeItem(Constants.TOKEN);
    localStorage.removeItem('userid');
    localStorage.removeItem('username');
    this.isAuthenticated.next(false);
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }


  static getEmail(): string {
    let email = "";
    email = localStorage.getItem("email");

    if (localStorage.getItem(Constants.CREDENTIALS)) {
      const credentials = JSON.parse(localStorage.getItem(Constants.CREDENTIALS));
      email = credentials.email ?? "";
    }

    return email;
  }
}
